import React, {useEffect} from 'react';
import {useFormContext} from 'react-hook-form';
import {TForm} from '@src/components/_views/configurable/import-view/file-list/.types';
import useUniqueId from '@src/hooks/useUniqueId';
import Translate from '@src/components/Translate/Translate';
import Switch from '@src/components/Fields/Switch';

export default function HasHeader() {
    const {setValue, watch} = useFormContext<TForm>();
    const id = useUniqueId();

    const value = watch('hasHeader');

    useEffect(() => {
        setValue('headerRowIndex', value ? 0 : null);
    }, [setValue, value]);

    return <div className="d-flex align-items-center">
        <Translate
                tag="label"
                message="List:ImportRecords.item-config.fields.has-header"
                htmlFor={id}
                className="col-form-label cursor-pointer me-2"
        />
        <Switch
                label=""
                id={id}
                checked={value === true}
                onChange={() => {
                    setValue('hasHeader', !(value === true));
                }}
                containerClassName="mb-0"
        />
    </div>;
}
